import { RankVendor } from 'src/types'

export type VenuePerformanceDetails = {
  venueId: string
  brand: string
  city: string
  state: string
  county: string
  category: string
  msa?: { code: string; name: string }
  placeId?: string
  storeId?: number
}

export type VenuePerformanceCategory = {
  code: string
  label: string
  type: string
}

export enum VenuePerformanceLocale {
  CITY = 'City',
  METRO = 'Metro Area',
  COUNTY = 'County',
  STATE = 'State',
  NATIONAL = 'National',
}

export type VenuePerformanceInfo = {
  details: VenuePerformanceDetails
  categories: VenuePerformanceCategory[]
  locales: VenuePerformanceLocale[]
}
export type PerformanceVenueInfoResponse = VenuePerformanceInfo

// TODO(bmc): BEFORE MERGE - clean this ridiculous type up
export type PerformanceVenueResponse = {
  venue: VenuePerformanceInfo & {
    rankMonthly: number
    rankTotal: number
    average: number
    median: number
    total: number
  }
  summary: {
    total: {
      average: number
      median: number
    }
    monthly: {
      average: number
      median: number
    }
    venues: number
  }
}

export type PerformanceRanking = {
  range: {
    start: number
    end: number
  }
  average: number
}

export type PerformanceRankedResponse = PerformanceVenueResponse & {
  rankings: PerformanceRanking[]
}

export type PerformanceCategoryTrendsResponse = Array<{
  month: string
  venue: number
  city: number
  msa?: number
  county: number
  state: number
  nation: number
}>

export type PerformanceCategoryTrendsAndAveragesResponse = {
  averages: {
    [key: string]: { average: number; median: number } | { average: number; median: number; count: number } | undefined
    venue: { average: number; median: number }
    city: { average: number; median: number; venues: number }
    msa?: { average: number; median: number; venues: number }
    county: { average: number; median: number; venues: number }
    state: { average: number; median: number; venues: number }
    nation: { average: number; median: number; venues: number }
  }
  trends: PerformanceCategoryTrendsResponse
}

export type PerformanceRankedVenue = {
  rank: number
  venueId: string
  brand: string
  address: string
  category: string
  city: string
  state: string
  zipCode: string
  monthlyAverage: number
}

export type PerformanceVenueRequest = { venueId: string }
export type PerformanceBrandHistogramRequest = { venueId: string; locale: VenuePerformanceLocale; provider: RankVendor }
export type PerformanceBrandRankedRequest = PerformanceBrandHistogramRequest
export type PerformanceCategoryHistogramRequest = { venueId: string; locale: VenuePerformanceLocale; category: string }
export type PerformanceCategoryRankedRequest = PerformanceCategoryHistogramRequest

type RankedVenueRequest = {
  venueId: string
  locale: VenuePerformanceLocale
  minRank: number
  maxRank: number
}

export type VenuesRankedByCategoryRequest = RankedVenueRequest & { category: string }
export type VenuesRankedByBrandRequest = RankedVenueRequest & { brand: string }
export type VenuesRankedRequest = VenuesRankedByCategoryRequest | VenuesRankedByBrandRequest

export type PerformanceVenuesByRankResponse = PerformanceRankedVenue[]
export type PerformanceCategoryTrendsAndAveragesRequest = { venueId: string; category: string }

export type SafegraphRankedVenueRequest = RankedVenueRequest
export type MobileXRankedVenueRequest = RankedVenueRequest
